import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {

  constructor() { }

  transform(input: string): string {
    if (input) {
      return input.substring(0, 1).toUpperCase() + input.substring(1);
    }
    return input;

  }

}
